// extracted by mini-css-extract-plugin
module.exports = {"form":"ConsumablesForm_form__R5noO","consumablesPurchaseTypeSectionTitleTooltipWrapper":"ConsumablesForm_consumablesPurchaseTypeSectionTitleTooltipWrapper__pgeEi"};